import React from 'react';
import { useGetGenreCards } from './helpers';

export const SoundsByGenres = () => {
  const GENRE_CARDS = useGetGenreCards();

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex justify-between">
        <h3 className="font-title text-title-m font-medium md:text-title-l">Sounds by Genre</h3>
      </div>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-4 lg:grid-cols-5 xl:grid-cols-6">
        {GENRE_CARDS}
      </div>
    </div>
  );
};
